// extracted by mini-css-extract-plugin
module.exports = {"container":"add-card_container__3g8yZ","content":"add-card_content__3hWgk","title":"add-card_title__11IkY","close":"add-card_close__2ZAzL"};